var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M0 15.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L14.81 7.94l-3.75-3.75L.15 15.1c-.1.1-.15.22-.15.36zM17.71 5.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z", id: "id-14a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(3 2)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "id-15b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#id-14a" })
      ),
      React.createElement(
        "g",
        { mask: "url(#id-15b)", fill: "currentColor", fillRule: "nonzero" },
        React.createElement("path", { d: "M-3-2h24v24H-3z" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/assets/icons/edit.svg